import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import MarketingReveal from './MarketingReveal';
import { EXTRAORDINARY_SLIDES } from './homeDummyContent';

const INTERVAL_MS = 6000;

/**
 * Full-bleed editorial carousel — Peerspace “Where extraordinary begins”.
 */
const MarketingExtraordinaryBand = () => {
  const [active, setActive] = useState(0);

  useEffect(() => {
    const timer = window.setInterval(() => {
      setActive((prev) => (prev + 1) % EXTRAORDINARY_SLIDES.length);
    }, INTERVAL_MS);
    return () => window.clearInterval(timer);
  }, []);

  const slide = EXTRAORDINARY_SLIDES[active];

  return (
    <section className="relative min-h-[70vh] overflow-hidden text-m-on-dark sm:min-h-[78vh]">
      {EXTRAORDINARY_SLIDES.map((item, index) => (
        <img
          key={item.id}
          src={item.image}
          alt=""
          className={`absolute inset-0 h-full w-full object-cover transition-opacity duration-1000 ${
            index === active ? 'opacity-100' : 'opacity-0'
          }`}
          loading={index === 0 ? 'eager' : 'lazy'}
          aria-hidden={index !== active}
        />
      ))}
      <div className="absolute inset-0 bg-black/50" aria-hidden="true" />

      <MarketingReveal className="relative z-10 flex min-h-[70vh] flex-col justify-end px-4 py-16 sm:min-h-[78vh] sm:px-6 sm:py-20">
        <div className="mx-auto w-full max-w-5xl">
          <p className="mb-4 text-[11px] font-medium uppercase tracking-[0.16em] text-white/60">
            {slide.kicker}
          </p>
          <h2 className="marketing-section-title mb-4 max-w-2xl text-m-on-dark">
            {slide.title}
          </h2>
          <p className="marketing-body-lg mb-8 max-w-lg text-white/80">{slide.body}</p>
          <Link to="/browse-vendors" className="marketing-btn marketing-btn-ghost gap-2">
            Explore vendors
            <ArrowRight className="h-4 w-4" />
          </Link>

          <div className="mt-10 flex gap-2">
            {EXTRAORDINARY_SLIDES.map((item, index) => (
              <button
                key={item.id}
                type="button"
                aria-label={`Show slide ${index + 1}`}
                onClick={() => setActive(index)}
                className={`h-1 rounded-full transition-all ${
                  index === active ? 'w-10 bg-white' : 'w-4 bg-white/40 hover:bg-white/60'
                }`}
              />
            ))}
          </div>
        </div>
      </MarketingReveal>
    </section>
  );
};

export default MarketingExtraordinaryBand;
